import { createSlice } from '@reduxjs/toolkit'
import DtoCampaignWithStats from 'pgsse/dto/DtoPgsseCampaignWithStats'
import DtoPgsseCampaign from 'pgsse/dto/DtoPgsseCampaign'
import DtoPgsseDiagnostic from 'pgsse/dto/DtoPgsseDiagnostic'
import DtoPgsseDiagnosticWithStats from 'pgsse/dto/DtoPgsseDiagnosticWithStats'
import DtoPgsseForm from 'pgsse/dto/DtoPgsseForm'
import DtoPgsseSurvey from 'pgsse/dto/DtoPgsseSurvey'
import DtoCMSSurvey from 'events/dto/DtoCMSSurvey'
import DtoDangerTable from 'pgsse/dto/DtoDangerTable'
import DtoPgsseDiagnosticWithDanger from 'pgsse/dto/DtoPgsseDiagnosticWithDangers'
import DtoPgsseDiagnosticWithActions from 'pgsse/dto/DtoPgsseDiagnosticWithActions'
import DtoActionTable from 'pgsse/dto/DtoActionTable'
import DtoPgsseDiagnosticWithIndicators from 'pgsse/dto/DtoPgsseDiagnosticWithIndicators'
import DtoPgsseImport from 'pgsse/dto/DtoPgsseImport'

export const initialState = {
    surveys: [],
    dashboardPhase1: [],
    dashboardPhase2: {},
    diagnostics: [],
    diagnostic: new DtoPgsseDiagnostic({}),
    campaign: new DtoPgsseCampaign({}),
    form: new DtoPgsseForm({}),
    survey: new DtoCMSSurvey({}),
    dangers: [],
    actions: [],
    diagnosticDangers: [],
    diagnosticElements: [],
    diagnosticActions: [],
    diagnosticIndicators: [],
    indicators: [],
    indicatorValues: [],
    imports: [],
    importDangers: [],
}

const store = createSlice({
    name: 'pgsse',
    initialState,
    reducers: {
        receiveDashboardPhase1: (state, action) => {
            state.dashboardPhase1 = action.payload.map(p => new DtoCampaignWithStats(p))
        },
        receiveDashboardPhase2: (state, action) => {
            state.dashboardPhase2 = action.payload
        },
        receivePhase1List: (state, action) => {
            state.diagnostics = action.payload.map(p => new DtoPgsseDiagnosticWithStats(p))
        },
        receivePhase2List: (state, action) => {
            state.diagnosticDangers = action.payload.map(p => new DtoPgsseDiagnosticWithDanger(p))
        },
        receivePhase3List: (state, action) => {
            state.diagnosticActions = action.payload.map(p => new DtoPgsseDiagnosticWithActions(p))
        },
        receivePhase4List: (state, action) => {
            state.diagnosticIndicators = action.payload.map(p => new DtoPgsseDiagnosticWithIndicators(p))
        },
        receiveIndicators: (state, action) => {
            state.indicators = action.payload
        },
        receiveIndicatorValues: (state, action) => {
            state.indicatorValues = action.payload
        },
        receiveDiagnostic: (state, action) => {
            state.diagnostic = new DtoPgsseDiagnostic(action.payload)
        },
        receiveCampaign: (state, action) => {
            state.campaign = new DtoPgsseCampaign(action.payload)
        },
        receiveForm: (state, action) => {
            state.form = new DtoPgsseForm(action.payload)
        },
        receiveSurveys: (state, action) => {
            state.surveys = action.payload.map(p => new DtoPgsseSurvey(p))
        },
        receiveSurvey: (state, action) => {
            state.survey = new DtoCMSSurvey(action.payload)
        },
        receiveDanger: (state, action) => {
            state.dangers = action.payload.map(p => new DtoDangerTable(p))
        },
        receiveDiagnosticElements: (state, action) => {
            state.diagnosticElements = action.payload
        },
        receiveAction: (state, action) => {
            state.actions = action.payload.map(p => new DtoActionTable(p))
        },
        receiveImportDangers: (state, action) => {
            state.importDangers = action.payload.map(p => new DtoDangerTable(p))
        },
        receiveImports: (state, action) => {
            state.imports = action.payload.map(p => new DtoPgsseImport(p))
        },
    },
})

export const PgsseActionConstant = store.actions
export default store.reducer